module.exports = __webpack_public_path__ + "img/04.e190f363.png";